import { ProfileState } from './profile.state';
import { Action, createReducer, on } from '@ngrx/store';
import {
    profileClearCache, profileEndImpersonation,
    profileFailure, profileImpersonate,
    profileReceived,
    profileRequest, profileSaveAvatar,
    profileSelectIcons,
    profileSelectTheme,
    profileSettingUpdated,
    profileTermsAgreed
} from './profile.actions';
import { PricingDisplayEnum } from '../../enum/pricing-display.enum';


const initialState: ProfileState = {
    profile: {
        id: null,
        consumerTheme: 'theme-dlvrd',
        userAvatar: null,
        identityName: null,
        logoUrl: null,
        courierConfiguration: {
            options: [],
            packagingTypes: [],
            forms: [],
            couriers: []
        },
        interfaceModification: {
            refs: {
                grouping: [],
                min_count: 1,
                max_count: 10
            },
            third_party_accounts: []
        },
        roles: [],
        messageUrl: null,
        newShipmentTemplate: {},
        icons: 'default',
        settings: [],
        timestamp: null,
        notices: [],
        currency: 'USD',
        organizationName: '',
        email: '',
        pricingDisplay: PricingDisplayEnum.DEFAULT,
        outstandingTerms: [],
        insuranceCategories: [],
        currencyConversion: [],
        logins: [],
        passkeyEnabled: false,
        impersonator: null,
        fullName: '',
        username: '',
        privacyPolicyUrl: null,
        generalTermsUrl: null,
        packageTemplates: []
    },
    busy: true,                     // initially busy as we never want to show the initial state
    errors: []
};

const reducer = createReducer(
    initialState,
    on(profileRequest, (state) => ({ ...state, busy: true, profile: { ...state.profile } })),
    on(profileReceived, (state, { profile }) => ({ ...state, busy: false, profile })),
    on(profileFailure, (state) => ({ ...state, profile: { ...state.profile }, busy: false })),
    on(profileClearCache, () => ({ ...initialState, busy: false })),
    on(profileSelectTheme, (state, { name }) => ({ ...state, profile: { ...state.profile, consumerTheme: name } })),
    on(profileSelectIcons, (state, { name }) => ({ ...state, profile: { ...state.profile, icons: name } })),
    on(profileImpersonate, (state, { username }) => ({ ...state, busy: true })),
    on(profileEndImpersonation, (state) => ({ ...state, busy: true })),
    on(profileSaveAvatar, (state, { userAvatar }) => ({ ...state, busy: true })),
    on(profileSettingUpdated, (state, { id, value }) => ({
        ...state, profile: {
            ...state.profile,
            settings: state.profile.settings.map(s => ({
                    ...s, value: s.id === id ? value : s.value
                })
            )
        }
    })),
    on(profileTermsAgreed, (state, { id }) => ({
        ...state, profile: {
            ...state.profile,
            outstandingTerms: state.profile.outstandingTerms.filter(t => t.id !== id)
        }
    }))
);

export function profileReducer(state: ProfileState | undefined, action: Action): any {
    return reducer(state, action);
}
